import React from 'react'
import {
  Avatar,
  Divider,
  Drawer,
  List,
  ListSubheader,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Link } from 'react-router-dom'
import {
  BeginnerStrengtheningBeads,
  SupremeStrengtheningBead,
  SuperiorStrengtheningBead,
  IntermediateStrengtheningBeads,
  CraftNodeFavor
} from 'src/util/images'

const useStyle = makeStyles({
  urlList: {
    width: 240
  }
})

type Props = {
  open: boolean
  onClose: () => void
}

const HomeIcon: React.VFC = () => <Avatar src={SupremeStrengtheningBead} />
const MotionCharactorIcon: React.VFC = () => (
  <Avatar src={SuperiorStrengtheningBead} />
)
const NetaIcon: React.VFC = () => (
  <Avatar src={IntermediateStrengtheningBeads} />
)
const NetaImageIcon: React.VFC = () => (
  <Avatar src={BeginnerStrengtheningBeads} />
)
const ChangeLogIcon: React.VFC = () => <Avatar src={CraftNodeFavor} />

const links = [
  { text: '各種モーション', icon: <HomeIcon />, to: '/' },
  {
    text: 'キャラ毎モーション',
    icon: <MotionCharactorIcon />,
    to: '/motion_charactor'
  },
  { text: 'ネタgif', icon: <NetaIcon />, to: '/neta' },
  { text: 'ネタ画像', icon: <NetaImageIcon />, to: '/netaimage' }
]

const otherLinks = [
  { text: '更新履歴', icon: <ChangeLogIcon />, to: '/change_log' }
]

const AppDrawer: React.VFC<Props> = React.memo(({ open, onClose }) => {
  const classes = useStyle()

  return (
    <Drawer open={open} onClose={onClose}>
      <div className={classes.urlList}>
        <Toolbar />
        <Divider />

        <List subheader={<li />}>
          <ListSubheader>リンク</ListSubheader>
          {links.map((e) => (
            <ListItem key={e.text} button component={Link} to={e.to}>
              <ListItemIcon>{e.icon}</ListItemIcon>
              <ListItemText>{e.text}</ListItemText>
            </ListItem>
          ))}

          <Divider />

          <ListSubheader>その他</ListSubheader>
          {otherLinks.map((e) => (
            <ListItem key={e.text} button component={Link} to={e.to}>
              <ListItemIcon>{e.icon}</ListItemIcon>
              <ListItemText>{e.text}</ListItemText>
            </ListItem>
          ))}
        </List>
      </div>
    </Drawer>
  )
})
AppDrawer.displayName = 'AppDrawer'

export default AppDrawer
